// extracted by mini-css-extract-plugin
module.exports = {"my-back-top":"fkTu6pvU"};